module.exports = __webpack_public_path__ + "img/contact-linkedin.8f2ee87a.svg";